import { React, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Root, classes } from './utils';
// import AuthenticationLeftGrid from '../common/AuthenticationLeftGrid';
import CodeSendThroughEmail from './CodeSendThroughEmail';
import CodeVerification from './CodeVerification';
import SetNewPassword from './SetNewPassword';
import { resetPassword } from '../../../../services/passwordApi';
import AuthenticationNewLeftGrid from '../common/AuthenticationNewLeftGrid';

const ResetPassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    verificationCode: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({
    email: false,
    verificationCode: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [step, setStep] = useState(1);

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const submitForm = async (data) => {
    const { email } = data;
    const { OTP } = data;
    const { newPassword } = data;
    const { confirmPassword } = data;
    const response = await resetPassword(
      email,
      OTP,
      newPassword,
      confirmPassword,
    );

    if (response) {
      navigate('/login');
    }
  };

  return (
    <Root className={classes.root}>
      <Grid container component="main" className={classes.containerMainGrid}>
        {/* this is common left grid for all authentication pages */}
        {/* <AuthenticationLeftGrid /> */}
        <AuthenticationNewLeftGrid />
        <>
          {step === 1 && (
            <CodeSendThroughEmail
              formData={formData}
              errors={errors}
              setErrors={setErrors}
              setFormData={setFormData}
              nextStep={nextStep}
              step={step}
            />
          )}
          {step === 2 && (
            <CodeVerification
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              nextStep={nextStep}
              prevStep={prevStep}
              step={step}
            />
          )}
          {step === 3 && (
            <SetNewPassword
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              prevStep={prevStep}
              step={step}
              submitForm={submitForm}
            />
          )}
        </>
      </Grid>
    </Root>
  );
};
export default ResetPassword;
